import styled from 'styled-components';
import { Paragraph, mq } from '@phishtool/ui';
export const StyledCardWrapper = styled.div.withConfig({ displayName: "StyledCardWrapper", componentId: "-1419k7d" }) `
  display: flex;
  gap: ${(props) => props.theme.spacers.xxl} ${(props) => props.theme.spacers.medium};

  ${mq({
    flexDirection: ['column', null, 'row'],
})}
`;
export const StyledCardParagraph = styled(Paragraph).withConfig({ displayName: "StyledCardParagraph", componentId: "-kgnjr9" }) `
  flex: 1;
`;
export const StyledDivider = styled.div.withConfig({ displayName: "StyledDivider", componentId: "-tyho27" }) `
  background-color: ${(props) => props.theme.colors.silverPearl};
  flex: 0 0 1px;

  ${mq({
    width: ['100%', null, null, 'auto'],
    maxWidth: ['none', '540px'],
})}
`;
